import { T } from '@app/components/translation';

import type { Extension } from 'types/extension';

type Props = {
  extension: Extension;
};

export const ExtensionOwner = ({ extension }: Props) => {
  const { ownerName } = extension;

  return (
    <T
      _str="By {owner}"
      owner={<span>{ownerName}</span>}
      _comment="Byline for each card on the Extension list, By entity-name"
    />
  );
};
